import { Reveal, Overline } from "./Reveal";

const STEPS = [
  { n: "01", t: "Enquire", d: "Share your details below and our admissions team reaches out." },
  { n: "02", t: "Visit", d: "Tour the campus, meet our educators and see a class in session." },
  { n: "03", t: "Enrol", d: "Complete a simple interaction and secure your child's seat." },
];

export const Admissions = () => (
  <section id="admissions" data-testid="admissions-section" className="relative py-28 lg:py-40 bg-maroon text-cream overflow-hidden">
    <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full border border-saffron/20" />
    <div className="absolute -top-10 -right-10 h-72 w-72 rounded-full border border-saffron/10" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <div className="max-w-3xl">
        <Reveal>
          <Overline dark>Admissions Open 2026–27</Overline>
          <h2 className="ff-display text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
            Give your child a
            <span className="italic text-saffron"> beginning</span> worth remembering.
          </h2>
          <p className="mt-6 text-cream/75 font-light max-w-xl text-lg">
            Seats are limited across Primary to Secondary. Reserve a campus visit and
            walk through the doors you saw on our home page.
          </p>
          <a
            href="#contact"
            data-testid="admissions-cta"
            className="mt-9 inline-flex px-8 py-3.5 rounded-full bg-cream text-maroon hover:bg-saffron hover:text-ink transition-colors duration-300"
          >
            Request Information
          </a>
        </Reveal>
      </div>

      <div className="mt-20 grid md:grid-cols-3 gap-px bg-saffron/20 border border-saffron/20">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="bg-maroon p-8 h-full">
              <span className="ff-display text-4xl text-saffron">{s.n}</span>
              <h3 className="ff-display text-2xl mt-3">{s.t}</h3>
              <p className="mt-3 text-cream/70 font-light leading-relaxed">{s.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
